import React from "react";
import { Controller } from "slate";
import { IS_IOS, IS_MAC } from "slate-dev-environment";
import { Plugin } from "slate-react";

interface HotkeyProps {
  key: string;
  action: (editor: Controller) => void;
}

/**
 * Slate plugin to trigger an editor action based on Ctrl/Cmd + keypress
 */
export const AddHotkey = ({ key, action }: HotkeyProps): Plugin => {
  const IS_APPLE = IS_IOS || IS_MAC;
  const IS_WINDOWS = !IS_APPLE;

  return {
    onKeyDown(event, editor, next) {
      const keyEvent = event as any as React.KeyboardEvent;

      if ((IS_WINDOWS && (keyEvent.ctrlKey && keyEvent.key === key))
      || (IS_APPLE && ((keyEvent.ctrlKey && keyEvent.key === key) || (keyEvent.metaKey && keyEvent.key === key)))) {
        event.preventDefault();
        action(editor);
      }
      // If it doesn't match our `key`, let other plugins handle it.
      return next();
    },
  };
};
